
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPiezoelectricCrystalOn as ObiPiezoelectricCrystalOnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-piezoelectric-crystal-on.js';
 
 
 

 
 export const ObiPiezoelectricCrystalOn = createComponent({
   react: React,
   tagName: 'obi-piezoelectric-crystal-on',
   elementClass: ObiPiezoelectricCrystalOnElement,
   events: {
     
   }
  });
 
 